export const removeUndefinedValues = <T extends object>(obj: T): T =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value !== 'undefined') {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as T);
